export default __webpack_public_path__ + "static/media/c001-E-commerce-2.320fe827.jpg";